{
  "eyebrow": "Cria a tua conta",
  "title": "Alguns detalhes sobre a tua empresa.",
  "sub": "Serás o administrador principal. Poderás convidar mais administradores depois da configuração.",
  "company": "Empresa",
  "companyName": "Nome da empresa",
  "companyVat": "Número de IVA",
  "companyVatBssHint": "Necessário para as declarações à Segurança Social belga (DIMONA).",
  "companyCountry": "País",
  "admin": "Administrador principal",
  "adminFirst": "Nome",
  "adminLast": "Apelido",
  "adminEmail": "Email de trabalho",
  "adminPhone": "Telefone",
  "adminPw": "Palavra-passe",
  "adminPwHint": "Pelo menos 10 caracteres, um número.",
  "adminPwShow": "Mostrar palavra-passe",
  "adminPwHide": "Ocultar palavra-passe",
  "terms": {
    "pre": "Aceito os",
    "t": "Termos de Serviço",
    "and": "e a",
    "p": "Política de Privacidade"
  },
  "cta": "Criar conta e continuar",
  "errors": {
    "required": "Obrigatório",
    "tooShort": "Demasiado curto",
    "invalidEmail": "Indica um email válido",
    "invalidVat": "Indica um número de IVA válido",
    "invalidBelgianVat": "Indica um número de IVA belga válido (p. ex., BE0123456789).",
    "invalidPhone": "Indica um telefone válido",
    "passwordWeak": "Pelo menos 12 caracteres com um número",
    "termsRequired": "Tens de aceitar os termos",
    "emailExists": "Este email já está a ser usado",
    "vatRequiredForBss": "O IVA é obrigatório para a Segurança Social belga",
    "network": "Erro de rede ou servidor. Tenta novamente.",
    "throttled": "Demasiadas tentativas. Tente novamente dentro de {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Vê a tua caixa de entrada",
    "awaitingSub": "Enviámos um link de verificação para {{email}}. Clique nele para ativar a sua conta e iniciar o seu teste gratuito.",
    "awaitingSubNoEmail": "Enviámos-lhe um link de verificação. Clique nele para ativar a sua conta e iniciar o seu teste gratuito.",
    "resend": "Reenviar email",
    "resendCooldown": "Reenviar em {{seconds}}s",
    "verifyingTitle": "A verificar…",
    "successTitle": "O seu teste gratuito de 30 dias começou!",
    "successSub": "Sem cartão de crédito. Inicie sessão no seu painel para começar a usar o Done-it.",
    "errorTitle": "Não foi possível verificar este link",
    "errorSub": "O link pode ter expirado. Recomeça a partir dos dados da tua conta.",
    "errorCta": "Voltar à conta",
    "interstitial": "Verificação de email",
    "subscribedTitle": "A sua conta está pronta",
    "subscribedSub": "O pagamento já foi concluído. Inicie sessão no painel para começar a usar o Done-it.",
    "subscribedCta": "Entrar no painel",
    "successCta": "Abrir o painel",
    "successNote": "Vai receber alguns e-mails úteis durante o teste e, perto do fim, um link para subscrever.",
    "awaitingSubFree": "Enviámos um link de verificação para {{email}}. Clique nele para ativar a sua conta gratuita — o Time Zero é gratuito para sempre, sem cartão de crédito.",
    "awaitingSubFreeNoEmail": "Enviámos-lhe um link de verificação. Clique nele para ativar a sua conta gratuita — o Time Zero é gratuito para sempre, sem cartão de crédito.",
    "successTitleFree": "A sua conta gratuita está pronta!",
    "successNoteFree": "O Time Zero é gratuito para sempre dentro dos seus limites. Faça upgrade a qualquer momento para uso ilimitado."
  }
}
